// @owners { team: patients-team }
import { ActionSheetContext, Button, LgPadding, Row, Separator } from '@alto/design-system';
import { ConfirmDeleteActionSheet } from '@alto/features';
import React, { useContext } from 'react';
import { formatPaymentMethod } from '~shared/features/payment-methods/helpers';
import { type PaymentMethod } from '~shared/types';
import { ACHLabel } from '~web/features/payments/components/ACHLabel';
import { PlaidLinkButton } from '~web/features/payments/components/PlaidLinkButton';

type Props = {
  paymentMethods: PaymentMethod[];
  deletePaymentMethod: (paymentMethod: PaymentMethod) => void;
};

export const AchPaymentMethods = ({ paymentMethods, deletePaymentMethod }: Props) => {
  const { closeActionSheet, setActiveActionSheet } = useContext(ActionSheetContext);

  if (paymentMethods.length > 0) {
    return (
      <>
        {paymentMethods.map((achPaymentMethod) => {
          const description = formatPaymentMethod(achPaymentMethod);
          const bank = achPaymentMethod.details || {};
          return (
            <React.Fragment key={`ach-${achPaymentMethod.id}`}>
              <LgPadding>
                <Row spaceBetween>
                  <ACHLabel plaidData={bank} />
                  <Button
                    type="tertiary"
                    small
                    label="DELETE"
                    accessibilityLabel={`Press to delete ACH payment method ending for ${description}`}
                    onPress={() => {
                      setActiveActionSheet(
                        <ConfirmDeleteActionSheet
                          analyticsName="confirm delete ach payment"
                          description={`the ACH payment method for ${description}`}
                          onConfirm={() => {
                            deletePaymentMethod(achPaymentMethod);
                            closeActionSheet();
                          }}
                        />,
                      );
                    }}
                  />
                </Row>
              </LgPadding>
              <Separator />
            </React.Fragment>
          );
        })}
      </>
    );
  }

  return (
    <>
      <Separator />
      <LgPadding>
        <Row right>
          <PlaidLinkButton />
        </Row>
      </LgPadding>
    </>
  );
};
